import { useState } from "react";
import helpers from "@/utils/helpers";
import {
  MARKING_EVENT_TRACK_METADATA,
  MARKING_EVENT_TRACK_LOG,
} from "@/consts/markingsConst";
import {
  SUCCESS_STEP_ONE,
  SUCCESS_STEP_TWO,
} from "@/consts/const";
import history from "@/utils/history";


export const useRuteHandler = (props) => {
  const handleRuteRules = (isSuccess, placa) => {
    const { nextStepHP, nextStep, errorStep } = props;
    let nextPage = '';

    switch (isSuccess) {
      case SUCCESS_STEP_ONE:

        helpers.getTagEvent('trackConsultSoat');
        helpers.getTagMetadata('Consulta SOAT - Placa', placa, MARKING_EVENT_TRACK_METADATA)

        nextPage = nextStepHP;
        break;

      case SUCCESS_STEP_TWO:
        helpers.getTagEvent('trackConsultSoat');
        helpers.getTagMetadata('Consulta SOAT - Placa', placa, MARKING_EVENT_TRACK_METADATA)
        helpers.getTagMetadata('Consulta SOAT - Usuario', 'No tiene SOAT', MARKING_EVENT_TRACK_METADATA)
        helpers.getTagLog('Consulta SOAT - No se encontró información de la placa ingresada', MARKING_EVENT_TRACK_LOG)

        nextPage = nextStep;
        break;

      default:
        nextPage = errorStep;
    };

    return nextPage;
  };

  const handleSendGoRute = (isSuccess, plate) => {
    const rute = handleRuteRules(isSuccess, plate);
    history.push(rute);
  };

  return {
    handleSendGoRute
  }
};